const getWpDatabaseIdFromNodeId = (nodeId) => {
  if (!nodeId || typeof nodeId !== 'string') {
    return null
  }

  try {
    if (typeof globalThis === 'undefined') {
      return null
    }

    let decoded = ''

    if (typeof globalThis.atob === 'function') {
      decoded = globalThis.atob(nodeId)
    } else if (globalThis.Buffer && typeof globalThis.Buffer.from === 'function') {
      decoded = globalThis.Buffer.from(nodeId, 'base64').toString('utf8')
    }

    if (!decoded) {
      return null
    }

    // WPGatsby IDs usually decode to strings like "post:123".
    const match = decoded.match(/(\d+)(?!.*\d)/)

    if (!match) {
      return null
    }

    return parseInt(match[1], 10)
  } catch (error) {
    return null
  }
}

export default getWpDatabaseIdFromNodeId
